export const SIZE_DIMENSION_KEYS = ['us', 'eu', 'uk', 'jp', 'br', 'mx', 'cn'] as const;

export type SizeDimensionKey = (typeof SIZE_DIMENSION_KEYS)[number];

export interface SizeDimensions extends Partial<Record<SizeDimensionKey, string>> {
  code: string;
}
